import { apiFetch, withToken } from "./http";
import type { ProductProfile, SPRDecision, Match } from "./gspr";

// Üretilen (immutable) dokümanlar API'si. Backend: go/internal/api/handler/documents.go

const BASE = "/api/v1/documents";

// Liste öğesi — metadata (ağır JSONB alanları olmadan).
export type GeneratedDocMeta = {
  id: number;
  product_name: string;
  risk_class?: string;
  document_code?: string;
  version?: string;
  status?: "preparing" | "ready"; // arka plan üretim durumu (yoksa ready sayılır)
  created_at: string;
};

// Tam snapshot — read-only SPR map görünümü için (spr-map yanıtıyla aynı şekil).
export type GeneratedDocDetail = {
  id: number;
  product_name: string;
  risk_class?: string;
  document_code?: string;
  version?: string;
  created_at: string;
  profile: ProductProfile;
  classification: Match;
  decisions: SPRDecision[];
  summary: { total: number; applicable: number; not_applicable: number };
  immutable: boolean;
};

export async function listDocuments(): Promise<{ count: number; documents: GeneratedDocMeta[] }> {
  const res = await apiFetch(`${BASE}/`);
  if (!res.ok) throw new Error(`listDocuments: HTTP ${res.status}`);
  return res.json();
}

export async function getDocument(id: number): Promise<GeneratedDocDetail> {
  const res = await apiFetch(`${BASE}/${id}`);
  if (!res.ok) throw new Error(`getDocument: HTTP ${res.status}`);
  return res.json();
}

// documentDocxURL — snapshot'tan DOCX indirme (LLM çağrılmaz, immutable).
export function documentDocxURL(id: number): string {
  return withToken(`${BASE}/${id}/document.docx`);
}

// --- Doküman çevirisi (Backend: go/internal/api/handler/translate.go) ---

// Çeviri kaydı — kaynak dokümana bağlı, hedef dilinde. İndirme documentDocxURL(id) ile.
export type TranslationMeta = {
  id: number;
  product_name: string;
  language?: string; // hedef dil kodu (de/fr/tr...)
  source_doc_id?: number;
  status?: "preparing" | "ready";
  created_at: string;
};

// translateDocument — kaynak GSPR'nin doldurulan kısımlarını hedef dile çevir (async, 100 kredi).
export async function translateDocument(sourceDocId: number, language: string): Promise<{ id: number; status: string }> {
  const res = await apiFetch(`/api/v1/translate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ source_doc_id: sourceDocId, language }),
  });
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try { const j = await res.json(); if (j?.error) msg = j.error; } catch { /* ignore */ }
    throw new Error(msg);
  }
  return res.json();
}

export async function listTranslations(): Promise<{ translations: TranslationMeta[] }> {
  const res = await apiFetch(`/api/v1/translations`);
  if (!res.ok) throw new Error(`listTranslations: HTTP ${res.status}`);
  return res.json();
}
